import { ReactNode, createContext, useContext } from 'react'

import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client'

export type GraphQLClient = ApolloClient<NormalizedCacheObject>

interface GraphQLProviderProps {
  client: GraphQLClient
  children?: ReactNode
}

const apolloClientContext = createContext<GraphQLClient | null>(null)

export const GraphQLProvider = ({ client, children }: GraphQLProviderProps) => {
  return (
    <apolloClientContext.Provider value={client}>
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </apolloClientContext.Provider>
  )
}

export const useGraphQLClient = () => useContext(apolloClientContext)
